// LOS ANDARIEGOS — Carta 2026
// Contenido exacto del menú. No modificar nombres, descripciones ni precios.

export const CATEGORIES = [
  {
    id: "entradas",
    number: "01",
    title: "Entradas y Snacks",
    subtitle: "Para empezar",
    items: [
      {
        id: "alitas",
        name: "Alitas con papas",
        price: 85,
        description:
          "6 piezas acompañadas con 100 g de papas.",
        variantsLabel: "Sabores",
        variantsInline: ["BBQ", "Mango Habanero", "Tamarindo", "Búfalo"],
      },
      {
        id: "toritos",
        name: "Toritos",
        price: 59,
        description:
          "2 chiles cuaresmeños rellenos de queso Philadelphia envueltos en tocino.",
      },
      {
        id: "papas-francesa",
        name: "Papas a la francesa",
        subtitle: "200 g",
        price: 50,
      },
      {
        id: "papas-gajo",
        name: "Papas gajo",
        subtitle: "200 g",
        price: 50,
      },
      {
        id: "boneless",
        name: "Boneless",
        subtitle: "250 g",
        price: 99,
      },
      {
        id: "nachos",
        name: "Nachos especiales",
        price: 99,
      },
      {
        id: "salchipulpos",
        name: "Salchipulpos con papas",
        price: 69,
      },
    ],
  },
  {
    id: "platillos",
    number: "02",
    title: "Platillos",
    subtitle: "De la casa",
    items: [
      {
        id: "huesitos",
        name: "Huesitos Andariegos",
        price: 70,
        variantsInline: ["Naturales", "BBQ"],
      },
      {
        id: "enchiladas",
        name: "Enchiladas verdes y suizas",
        variants: [
          { label: "Pollo", price: 79 },
          { label: "Arrachera", price: 129 },
        ],
      },
      {
        id: "flautas",
        name: "Flautas ahogadas de pollo en salsa verde",
        description: "3 piezas.",
        price: 79,
      },
      {
        id: "chilaquiles",
        name: "Chilaquiles verdes o rojos",
        description: "Chipotle morita.",
        variants: [
          { label: "Pollo", price: 79 },
          { label: "Costilla", price: 89 },
          { label: "Arrachera", price: 119 },
        ],
      },
    ],
  },
  {
    id: "burgers",
    number: "03",
    title: "Burgers",
    subtitle: "Al grill",
    items: [
      {
        id: "mexa",
        name: "Hamburguesa Mexa",
        price: 99,
        description:
          "Jugosa carne de res, tocino, queso gouda, aros de cebolla, guacamole, lechuga, jitomate y cebolla. Incluye 100 g de papas a la francesa.",
      },
      {
        id: "special-chef",
        name: "Hamburguesa Special Chef",
        price: 99,
        description:
          "Jugosa carne de res, tocino, queso gouda, piña, queso amarillo, salchicha, lechuga, jitomate y cebolla. Incluye 100 g de papas a la francesa.",
      },
      {
        id: "hocho",
        name: "Hocho Especial",
        price: 79,
        description:
          "Dos hot dogs con tocino, chile cuaresmeño, queso crema y guacamole. Incluye 100 g de papas.",
      },
    ],
  },
  {
    id: "aguachiles",
    number: "04",
    title: "Aguachiles",
    subtitle: "Frescos",
    items: [
      {
        id: "aguachile-cubano",
        name: "Aguachile Cubano",
        price: 189,
      },
      {
        id: "aguachile-maracuya",
        name: "Aguachile de Maracuyá",
        price: 189,
      },
    ],
  },
  {
    id: "tacos",
    number: "05",
    title: "Tacos Especiales",
    subtitle: "De la parrilla",
    items: [
      {
        id: "mix-tacuches",
        name: "Mix de Tacuches",
        price: 110,
        description:
          "Taco de arrachera. Taco de chorizo argentino. Taco de chistorra con queso gouda. Incluye papas y guacamole.",
      },
      {
        id: "trio-arrachera",
        name: "Trío de Arrachera",
        price: 130,
        description:
          "3 tacos de arrachera. Incluye papas y guacamole.",
      },
    ],
  },
  {
    id: "ensaladas",
    number: "06",
    title: "Ensaladas",
    subtitle: "Ligeras",
    items: [
      {
        id: "ensalada-bbq",
        name: "Ensalada BBQ",
        price: 85,
        description:
          "Mix de lechugas, germen, pimientos, pechuga a la plancha, barbecue, arándanos, jitomate cherry y aceite de oliva.",
      },
      {
        id: "ensalada-chef",
        name: "Ensalada del Chef",
        price: 85,
        description:
          "Mix de lechugas, germen, pimientos, pechuga asada, crotones, aceitunas, jitomate cherry, aderezo ranch y aceite de oliva.",
      },
    ],
  },
  {
    id: "bebidas",
    number: "07",
    title: "Bebidas",
    subtitle: "Para acompañar",
    items: [
      {
        id: "mojito",
        name: "Mojito sin alcohol",
        variantsLabel: "Sabores",
        variantsInline: ["Tradicional", "Maracuyá", "Frutos rojos"],
        variants: [
          { label: "½ litro", price: 50 },
          { label: "1 litro", price: 90 },
        ],
      },
      {
        id: "cerveza-barril",
        name: "Cerveza de barril",
        description: "Clara u oscura. Victoria o Corona.",
        variants: [
          { label: "½ litro", price: 45 },
          { label: "1 litro", price: 90 },
        ],
      },
      {
        id: "michelada",
        name: "Michelada o Cubana",
        variants: [
          { label: "½ litro", price: 55 },
          { label: "1 litro", price: 99 },
        ],
      },
      {
        id: "clamatada",
        name: "Cerveza Clamatada",
        variants: [
          { label: "½ litro", price: 60 },
          { label: "1 litro", price: 110 },
        ],
      },
      {
        id: "cerveza-sabor",
        name: "Cervezas de sabor",
        variantsLabel: "Sabores",
        variantsInline: ["Tamarindo", "Mango", "Maracuyá"],
        variants: [
          { label: "½ litro", price: 50 },
          { label: "1 litro", price: 100 },
        ],
      },
      {
        id: "cerveza-camarones",
        name: "Cerveza con camarones",
        variants: [
          { label: "½ litro", price: 80 },
          { label: "1 litro", price: 155 },
        ],
      },
      {
        id: "cerveza-media",
        name: "Cervezas de media",
        variantsLabel: "Opciones",
        variantsInline: [
          "Corona",
          "Pacífico",
          "Negra Modelo",
          "Modelo Especial",
          "Heineken",
          "Heineken 0.0",
        ],
        price: 45,
        priceSuffix: "c/u",
      },
      {
        id: "tarro-preparado",
        name: "Tarro preparado",
        variantsLabel: "Opciones",
        variantsInline: ["Michelado", "Cubano", "Clamatado"],
        price: 10,
        pricePrefix: "+",
      },
      {
        id: "suerito",
        name: "Suerito",
        variants: [{ label: "½ litro", price: 45 }],
      },
      {
        id: "limonada",
        name: "Limonada o Naranjada con nieve de limón",
        price: 45,
      },
      {
        id: "sangria",
        name: "Sangría preparada",
        variants: [{ label: "½ litro", price: 45 }],
      },
      {
        id: "levanta-muertos",
        name: "Levanta Muertos",
        variants: [
          { label: "½ litro", price: 80 },
          { label: "1 litro", price: 155 },
        ],
      },
      {
        id: "agua-dia",
        name: "Agua del día",
        variants: [
          { label: "½ litro", price: 25 },
          { label: "1 litro", price: 45 },
        ],
      },
      {
        id: "refrescos",
        name: "Refrescos",
        variants: [
          { label: "Coca-Cola / Sidral Mundet", price: 30 },
          { label: "Boing", price: 25 },
          { label: "Botella de agua (500 ml)", price: 20 },
        ],
      },
    ],
  },
];

export const LOGO_SRC = "/assets/logo-andariegos.png";
